/*
*   ~ Project event keys go in here ~
*
*   Usage in components:
*
*   import Events from '@vaersaagod/tools/Events';
*   import * as eventKeys from '../lib/events';
*   Events.publish(eventKeys.SOME_EVENT, 'This ES6 shit is wack');
*
 */

export const MENU_OPEN = 'MENU_OPEN';
export const MENU_CLOSE = 'MENU_CLOSE';
export const MENU_TOGGLE = 'MENU_TOGGLE';
export const LOCK_MENU_BAR = 'LOCK_MENU_BAR';
export const UNLOCK_MENU_BAR = 'UNLOCK_MENU_BAR';
export const INFORMATION_PANEL_ACTIVATED = 'INFORMATION_PANEL_ACTIVATED';
export const INFORMATION_PANEL_UPDATE = 'INFORMATION_PANEL_UPDATE';
export const INFORMATION_PANEL_VISIBLE = 'INFORMATION_PANEL_VISIBLE';
export const INFORMATION_PANEL_HIDDEN = 'INFORMATION_PANEL_HIDDEN';
export const HEADER_BEFORE_SHOW = 'HEADER_SHOW_START';
export const HEADER_AFTER_SHOW = 'HEADER_AFTER_SHOW';
export const HEADER_BEFORE_HIDE = 'HEADER_BEFORE_HIDE';
export const HEADER_AFTER_HIDE = 'HEADER_AFTER_HIDE';
export const PROGRAMMATIC_SCROLL_START = 'PROGRAMMATIC_SCROLL_START';
export const PROGRAMMATIC_SCROLL_END = 'PROGRAMMATIC_SCROLL_END';




// WEBPACK FOOTER //
// ./src/js/lib/events.js